import { render, staticRenderFns } from "./UsersV2.vue?vue&type=template&id=ce5254b0&scoped=true&"
import script from "./UsersV2.vue?vue&type=script&lang=js&"
export * from "./UsersV2.vue?vue&type=script&lang=js&"
import style0 from "./UsersV2.vue?vue&type=style&index=0&id=ce5254b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5254b0",
  null
  
)

export default component.exports